import {
	AfterViewInit,
	Directive,
	ElementRef,
	Input,
	OnChanges,
	Optional,
	Renderer2,
	SimpleChanges
} from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Directive({
	selector: '[goAriaPressed]'
})
export class GoAriaPressedDirective implements AfterViewInit, OnChanges {
	@Input({ required: true })
	public goAriaPressed: boolean | 'true' | 'false' = false;

	private hasViewInitialized = false;

	constructor (
		private elementRef: ElementRef<HTMLElement>,
		private renderer: Renderer2,
		@Optional() private matSlideToggle?: MatSlideToggle
	) {}

	public ngAfterViewInit (): void {
		this.hasViewInitialized = true;
		this.updateAriaPressed();
	}

	public ngOnChanges (_changes: SimpleChanges): void {
		if (!this.hasViewInitialized) {
			return;
		}

		this.updateAriaPressed();
	}

	private updateAriaPressed (): void {
		const target = this.getTargetElement();
		this.renderer.setAttribute(
			target,
			'aria-pressed',
			String(this.goAriaPressed === true || this.goAriaPressed === 'true')
		);
	}

	private getTargetElement (): HTMLElement {
		return this.matSlideToggle?._switchElement?.nativeElement ?? this.elementRef.nativeElement;
	}
}
